import { axios } from '@/lib/axios';
import { useQuery } from 'react-query';
import posthog from 'posthog-js';
import { FullStory } from '@fullstory/browser';
import { setUser } from '@sentry/react';

export const getUserDetails = async () => {
  const res = await axios.get('/api/v1/tenant/users/me');
  return res;
};

export const useGetUserDetails = ({ config } = {}) => {
  return useQuery(['userDetails'], () => getUserDetails(), {
    onSuccess: (data) => {
      posthog.identify(data.userId, data);
      setUser({
        id: data.name,
        email: data.email,
      });
      FullStory('setIdentity', {
        uid: data.userId,
        properties: {
          displayName: data.name,
          email: data.email,
        },
      });
    },
  });
};
